import React from "react"
import PropTypes from "prop-types"
import { Layout, Row, Col } from "antd"
import { useNavigate, useLocation } from "react-router-dom"
import { useSelector } from "react-redux"
import { Avatar } from "ui/Avatar"
import { Text } from "ui/Typography"
import { Icon } from "ui/Icon"
import { routes } from "router/routes"
import { oldRoutes } from "router/old-routes"
import styles from "./HistoryHeader.module.css"
import classNames from "classnames"
import { colors } from "themes/variables"
import { USER_STATUS } from "../constants"

const { Header } = Layout

export const HistoryHeader = ({ participant, guideClientId, isMobile, isTablet }) => {
  const isSmallScreen = isMobile || isTablet
  const navigate = useNavigate()
  const back_url = useLocation().pathname
  const status = useSelector((state) => state.conversations.status[participant?.id]) || participant?.status
  const user = useSelector((state) => state.user)
  const isGuide = user.role === "guide_user"
  const guidePath = oldRoutes.publicGuidePath({ slug: participant?.slug }, { back_url })

  return (
    <Header className={classNames(styles.header, isSmallScreen && styles.smallScreen)}>
      {participant?.id && (
        <Row className={styles.row} justify={isSmallScreen ? "space-between" : "start"} align="middle">
          <Col>
            <button
              onClick={() => {
                isGuide ? navigate(routes.guideClientPath({ id: guideClientId })) : navigate(guidePath)
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  isGuide ? navigate(routes.guideClientPath({ id: guideClientId })) : navigate(guidePath)
                }
              }}
              className={styles.noStyleButton}
            >
              <Avatar src={participant.avatar} fullName={participant?.full_name} size={isMobile ? 40 : 52} />
            </button>
          </Col>
          <Col className="ml-m">
            <div className={classNames("flex-column", isSmallScreen && "align-center")}>
              <Text
                variant="sub"
                size="lg"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  isGuide ? navigate(routes.guideClientPath({ id: guideClientId })) : navigate(guidePath)
                }}
              >
                {participant?.full_name}
              </Text>
              <div className="flex align-center">
                {status === USER_STATUS.ONLINE && (
                  <span className={styles.onlinePill} style={{ backgroundColor: colors.onlineStatus }}></span>
                )}
                <Text variant="caption" type="secondary" color={status === USER_STATUS.ONLINE ? colors.onlineStatus : ""}>
                  {status}
                </Text>
              </div>
            </div>
          </Col>
          {isSmallScreen && (
            <Col onClick={() => navigate(routes.proMessagesRootPath())}>
              <Icon type="feather" name="ChevronLeft" width={24} height={24} color={colors.textSecondary} />
            </Col>
          )}
        </Row>
      )}
    </Header>
  )
}
// Add PropTypes validation
HistoryHeader.propTypes = {
  participant: PropTypes.shape({
    id: PropTypes.string,
    full_name: PropTypes.string,
    avatar: PropTypes.string,
    status: PropTypes.string
  }),
  guideClientId: PropTypes.string,
  isMobile: PropTypes.bool,
  isTablet: PropTypes.bool
}

// Default props (optional)
HistoryHeader.defaultProps = {
  participant: null,
  guideClientId: null,
  isMobile: false,
  isTablet: false
}
